import { ModelBase } from "@shoothill/core";
import { makeObservable, observable } from "mobx";

export class StudentEngagementModel extends ModelBase<StudentEngagementModel> {
    public id: string = "";
    public severityLevel: string = "";
    public wellBeingDescription: string = "";
    public involvementDescription: string = "";
    public displayColor: string = "";
    public type: number = 0;
    public ordinal: number = 0;
    public isDeleted: boolean = false;

    constructor() {
        super();
        makeObservable(this, {
            severityLevel: observable,
            wellBeingDescription: observable,
            involvementDescription: observable,
            displayColor: observable,
            type: observable,
            ordinal: observable,
        });
    }
}
